import axios from '@/utils/requset'
import { pageResponseHandler, responseHandler } from '@/utils/http'

/**
 * 附件 Url
 * @type {{uploadAttachment: string}}
 */
const AttachmentUrl = {
  uploadAttachment: '/base/attachment',
  deleteAttachment: '/base/attachment/deleteAttachment',
  copyAttachment: '/base/attachment/copyAttachment'
}

/**
 * 附件 Api
 * @type {{uploadAttachment: (function(): string)}}
 */
export const AttachmentApi = {
  // 上传附件
  uploadAttachment: () => {
    return process.env.VUE_APP_BASE_URL + AttachmentUrl.uploadAttachment
    // return '/api' + AttachmentUrl.uploadAttachment
  },
  // 删除附件
  deleteAttachment: (attachmentId) => {
    return axios({
      url: AttachmentUrl.deleteAttachment,
      method: 'post',
      data: qs.stringify({ id: attachmentId })
    })
  },
  copyAttachment: (parameter) => {
    return axios({
      url: AttachmentUrl.copyAttachment,
      method: 'get',
      params: parameter
    }).then(responseHandler)
  }
}

